import { useQuery } from '@tanstack/vue-query'

import { explorerApi } from '~/api/client'
import { EvmAddressDetailInfo } from '~/api/repository'
import { addressDetailKey } from '~/api/service/query-keys.const'

export const useFetchAddressDetail = (address: string) => {
  return useQuery([ ...addressDetailKey, address ], (): Promise<ViewAddressDetail> => {
    return explorerApi.addressController.getAddressDetail({ 
      requestBody:{
        address
      }
     }).then((res) => {
      return addressDetailDTO(res as EvmAddressDetailInfo)
    })
  })
}

type ViewAddressDetail = EvmAddressDetailInfo & {
  address: string;
  addressType: string;
  name: string;
  balance: string;
  balancePercent: string;
  tokenCount: string;
  firstTransactionTime: number;
  lastTransactionTime: number;
  formattedFirstTransactionTime: string;
  formattedLastTransactionTime: string;
  contractAddress: string;
  contractTransactionHash: string;
}

const addressDetailDTO = (addressDetail: EvmAddressDetailInfo): ViewAddressDetail => {
  // ui에 맞게 변형하면 됨
  return {
    ...addressDetail,
    address: addressDetail.ADDR.toLowerCase(),
    addressType: addressDetail.ADDRT,
    name: addressDetail.NM,
    balance: setComma(addressDetail.BL),
    balancePercent: setComma(setDigits(addressDetail.BLP, 7)),
    tokenCount: setComma(addressDetail.TKNCNT),
    firstTransactionTime: addressDetail.FTRXUT,
    lastTransactionTime: addressDetail.LTRXUT,
    formattedFirstTransactionTime: secondsToDate(addressDetail.FTRXUT),
    formattedLastTransactionTime: secondsToDate(addressDetail.LTRXUT),
    contractAddress: addressDetail.CCADDR.toLowerCase(),
    contractTransactionHash: addressDetail.CTRXHA.toLowerCase()
  }
}